<div class="geo-picker">
  <div class="geo-picker-head">
    <i class="fa-regular fa-map"></i>
    <span>{{ 'geo.map.title' | translate }}</span>
  </div>
  <p class="geo-picker-hint">{{ 'geo.map.hint' | translate }}</p>

  <div class="geo-picker-shell" #mapShell [class.is-fullscreen]="isFullscreen">
    <div class="geo-picker-map" #mapHost></div>

    <!-- Search / paste coordinates or a Google Maps URL -->
    <div class="geo-picker-search">
      <input type="text" class="geo-picker-search-input" [value]="searchTerm"
        (input)="onSearchInput($any($event.target).value)"
        (keydown.enter)="onSearchCommit()"
        (paste)="onSearchPaste()"
        [placeholder]="'geo.map.searchPlaceholder' | translate" />
      <i class="fa-solid fa-spinner fa-spin geo-picker-search-spin"
        *ngIf="isSearching || isResolvingUrl"></i>
      <ul class="geo-picker-results" *ngIf="results.length">
        <li *ngFor="let result of results" (click)="selectResult(result)">{{ result.label }}</li>
      </ul>
      <p class="geo-picker-search-error" *ngIf="searchError">{{ searchError | translate }}</p>
    </div>

    <!-- Locate me -->
    <button type="button" class="geo-picker-btn geo-picker-locate" (click)="locateMe()"
      [disabled]="isLocating" [title]="'geo.map.useMyLocation' | translate">
      <i class="fa-solid" [ngClass]="isLocating ? 'fa-spinner fa-spin' : 'fa-location-crosshairs'"></i>
    </button>

    <!-- Layers: Leaflet's own control is added in initMap(), top-right, so all
         four base layers (Streets / Satellite / Hybrid / Terrain) are reachable
         instead of the two a boolean button could flip between. -->

    <!-- Fullscreen -->
    <button type="button" class="geo-picker-btn geo-picker-full" (click)="toggleFullscreen()"
      [title]="'geo.map.fullscreen' | translate">
      <i class="fa-solid" [ngClass]="isFullscreen ? 'fa-compress' : 'fa-expand'"></i>
    </button>

    <!-- Radius slider -->
    <div class="geo-picker-radius">
      <label>
        <span class="swatch entry"></span>{{ 'geo.map.radiusLabel' | translate }} {{ radiusValue }}m
        <span class="swatch prize"></span>{{ prizeRadiusValue }}m
        <!-- Manual only: the map must not re-frame itself while the radius is
             being tuned. -->
        <button type="button" class="geo-picker-fit" (click)="fitToRadiusNow()"
          [title]="'geo.map.fitToRadius' | translate">
          <i class="fa-solid fa-crop-simple"></i>
        </button>
      </label>
      <input type="range" min="5" max="500" step="1" [value]="radiusValue"
        (input)="onRadiusSlide($any($event.target).value)" />
    </div>

    <div class="geo-picker-status" *ngIf="isGeocoding">
      <i class="fa-solid fa-spinner fa-spin me-1"></i>{{ 'geo.map.locating' | translate }}
    </div>

    <div class="geo-picker-overlay" *ngIf="isLoading || hasFailed">
      <span *ngIf="isLoading">{{ 'geo.map.loading' | translate }}</span>
      <span *ngIf="hasFailed" class="text-danger">{{ 'geo.map.loadFailed' | translate }}</span>
    </div>
  </div>
</div>
